import { Box } from "@mui/material";
import CustomBreadcrumbs from "./CustomBreadcrumbs"; // Adjust the import path as needed
import BalanceButton from "./BalanceButton";

const PageHeader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        gap: 2,
      }}
    >
      <CustomBreadcrumbs />
      <BalanceButton />
    </Box>
  );
};

export default PageHeader;
